module.exports = __webpack_public_path__ + "img/tron (43).f30b78e1.jpg";